module.exports = __webpack_public_path__ + "static/media/abubukker.f43e1f5a.jpeg";